import {
    RECEIVE_COLLECTIONS_ABOUT,
    REQUEST_COLLECTIONS_ABOUT,
    SET_COLLECTIONS_ABOUT_ERROR
  } from '../constants/ActionTypes';

const initialState = {
    isFetching: false,
    isLoadingError: false
};

export default function collectionsAbout(state = initialState, action) {
    switch (action.type) {
        case SET_COLLECTIONS_ABOUT_ERROR:
            return {
                ...state,
                isFetching: false,
                isLoadingError: true
            };
        case REQUEST_COLLECTIONS_ABOUT:
            return {
                ...state,
                isFetching: true,
                isLoadingError: false
            };
        case RECEIVE_COLLECTIONS_ABOUT:
            return {
                ...state,
                isFetching: false,
                data: action.data
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/collectionsAbout.js